import { render, staticRenderFns } from "./sendMail.vue?vue&type=template&id=3bc40f12&scoped=true&"
import script from "./sendMail.vue?vue&type=script&lang=js&"
export * from "./sendMail.vue?vue&type=script&lang=js&"
import style0 from "./sendMail.vue?vue&type=style&index=0&id=3bc40f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc40f12",
  null
  
)

export default component.exports